import { Button, Stack, CircularProgress } from '@ltvco/refresh-lib/theme';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import React from 'react';

import { paginationButtonStyles } from './components';

export interface PaginationControlsProps {
  hasNext: boolean;
  hasPrevious: boolean;
  isLoading: boolean;
  onNext: () => void;
  onPrevious: () => void;
  showViewAll?: boolean;
  onViewAll?: () => void;
}

export const PaginationControls: React.FC<PaginationControlsProps> = ({
  hasNext,
  hasPrevious,
  isLoading,
  onNext,
  onPrevious,
  showViewAll = false,
  onViewAll,
}) => {
  if (showViewAll && onViewAll) {
    return (
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        sx={{ mt: 4, mb: 2 }}
      >
        <Button
          variant="outlined"
          onClick={onViewAll}
          sx={paginationButtonStyles}
        >
          View All
        </Button>
      </Stack>
    );
  }

  if (!hasNext && !hasPrevious) {
    return null;
  }

  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={2}
      sx={{ mt: 4, mb: 2 }}
    >
      <Button
        variant="outlined"
        startIcon={isLoading ? <CircularProgress size={16} /> : <ChevronLeft />}
        onClick={onPrevious}
        disabled={!hasPrevious || isLoading}
        sx={paginationButtonStyles}
      >
        {isLoading ? 'Loading...' : 'Previous'}
      </Button>

      <Button
        variant="outlined"
        endIcon={isLoading ? <CircularProgress size={16} /> : <ChevronRight />}
        onClick={onNext}
        disabled={!hasNext || isLoading}
        sx={paginationButtonStyles}
      >
        {isLoading ? 'Loading...' : 'Next'}
      </Button>
    </Stack>
  );
};
